import { useFeatures } from './useFeatures';

export const RESULT_CATEGORY_REGISTRY_FEATURE = 'resultCategoryRegistry';

/**
 * When on, Codings and Lab Results read result categories from the
 * medical-results-service project registry. Off by default until that
 * registry is ready to publish new categories without an app deploy.
 */
export const useIsResultCategoryRegistryEnabled = (): boolean =>
  useFeatures()(RESULT_CATEGORY_REGISTRY_FEATURE);
